module.exports = __webpack_public_path__ + "img/horizontal_3_5_8003.385a51f0.png";